'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { Notification } from '@/ui/notification/Notification'
import { Button, SelectValue } from 'react-aria-components'
import {
  SELECT_FIELD_HEIGHT,
  SELECT_FIELD_PADDING,
  selectFieldCva,
  selectValueCva,
} from '../select.styles'
import { SelectTriggerChrome } from './SelectTriggerChrome.client'

type SelectSingleTriggerProps = {
  inputId: string
  isOpen: boolean
  hasError: boolean
  isDisabled: boolean
  showLoader: boolean
  notificationNumber?: number
  /** Shown when `withTags` is false. Usually the `placeholder`. */
  displayLabel?: string
}

export function SelectSingleTrigger({
  inputId,
  isOpen,
  hasError,
  isDisabled,
  showLoader,
  notificationNumber,
  displayLabel,
}: SelectSingleTriggerProps) {
  return (
    <Button
      id={inputId}
      className={({ isFocusVisible }) =>
        twMerge(
          'group flex w-full items-center justify-between gap-1 rounded-sm',
          SELECT_FIELD_HEIGHT,
          SELECT_FIELD_PADDING,
          selectFieldCva({
            isOpen: isDisabled ? false : isOpen,
            isFocusVisible: isDisabled ? false : isFocusVisible,
            hasError: isDisabled ? false : hasError,
            isDisabled,
          }),
        )
      }
    >
      <span className="flex min-w-0 flex-1 items-center gap-1">
        <SelectValue
          className={twMerge(
            'min-w-0 truncate text-left text-md font-medium leading-light',
            selectValueCva({ isDisabled }),
          )}
        >
          {({ defaultChildren }) => displayLabel || defaultChildren}
        </SelectValue>
        {notificationNumber != null && (
          <Notification number={notificationNumber} aria-label={String(notificationNumber)} />
        )}
      </span>
      <SelectTriggerChrome showLoader={showLoader} isDisabled={isDisabled} isOpen={isOpen} />
    </Button>
  )
}
